import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
import { brandPagination } from 'src/pages/Dashboard/paginationStyle';

const ListQuotesComponent = styled('div')`
    ${typography.bodyXs}
    color: var(--sand-700);

    .box-search {
        margin-bottom: 20px;
        .ant-select {
            height: 40px;
            .ant-select-selector {
                min-width: 150px;
                border-color: var(--sand-400);
                box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
                ${typography.bodyMd}
                color: var(--sand-700);
            }
        }
        .ant-space-compact {
            .ant-select .ant-select-selector {
                box-shadow: none;
            }
        }
        .ant-input-compact-last-item {
            width: 280px;
            height: 40px;
            border-color: var(--sand-400);
            ${typography.bodyXs}
            .ant-input {
                ${typography.bodyXs}
                color: var(--sand-700);
            }
            .ant-input::placeholder {
                color: var(--sand-500);
            }
        }

        .field-search {
            width: 208px;
        }

        .ant-btn-primary:disabled {
            background: var(--orange-300);
            border-color: var(--orange-300);
            color: var(--sand-100);
            opacity: 0.42;
        }
        .ant-btn-primary {
            ${typography.buttonMd}
        }
    }

    .ant-table-pagination {
        position: relative;
        .ant-pagination-total-text {
            position: absolute;
            left: 0;
            top: 0;
            color: var(--sand-700);
        }
        .ant-pagination-options {
            position: absolute;
            left: 125px;
            top: 0;
        }
        .ant-pagination-jump-prev,
        .ant-pagination-jump-next {
            color: var(--blue-400);
        }
    }
    ${brandPagination}

    .ant-table-wrapper {
        .ant-table {
            scrollbar-color: auto;
            .ant-table-cell-scrollbar {
                box-shadow: none;
            }
        }
        .ant-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
        }
    }

    .ant-table-wrapper .ant-table.ant-table-small {
        .ant-table-thead > tr > th {
            padding-top: 11px;
            padding-bottom: 11px;
        }
        .ant-table-tbody > tr > td {
            ${typography.bodyXs}
            padding-top: 11px;
            padding-bottom: 11px;
            color: var(--sand-700);
            border-top: 1px solid transparent;
            border-bottom: 1px solid transparent;
        }
    }

    .ant-table-container {
        .ant-table-header {
            border-radius: 0px !important;

            .ant-table-selection-column .ant-table-selection {
                visibility: hidden;
                opacity: 0;
            }
        }
        .ant-table-cell {
            border-radius: 0px !important;
        }
        .ant-table-thead {
            th {
                ${typography.bodySm}
                font-weight: 700;
                color: var(--white);
                &::before {
                    display: none;
                }
            }
        }
        .highlight-row .ant-table-cell {
            background: var(--sand-100);
        }

        .ant-table-tbody > tr.ant-table-row:hover > td {
            background: var(--sand-300);
            color: var(--blue-400);
            border-top-color: var(--blue-300);
            border-bottom-color: var(--blue-300);
            &:first-of-type {
                box-shadow: inset 1px 0 0 var(--blue-300);
            }
            &:last-of-type {
                box-shadow: inset -1px 0 0 var(--blue-300);
            }
        }

        .box-action {
            .ant-btn-link {
                padding: 0;
                height: auto;
                position: relative;
                top: 3px;
                color: var(--blue-400);
            }
            .ant-btn-link:disabled {
                color: var(--blue-100);
            }
        }
    }

    .text-clear {
        color: var(--blue-400);
        cursor: pointer;
        margin-top: 10px;
    }
`;

export default ListQuotesComponent;
